(function () {
    'use strict';
    var controllerId = 'convenzione';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', 'commonAttach', fn_convenzione]);

    function fn_convenzione($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Convenzioni';
        vm.view = 'list';
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "convenzione"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.tSourceCode_CONV = "CONV";
        vm.isVisibleLinkDomanda = false;
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.maxStep = 3;
        vm.iFinestra = 1; //TERZA FINESTRA
        vm.actualAdesione = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.PdfReady = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.myPristine = false;
        vm.isClickDay = false;
        vm.nrMesiTrc = 0;
        vm.errorAccess = '';

        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.showPanelAccred3 = true;
        vm.showPanelAccred4 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;
        vm.setShowPanelAccred3 = setShowPanelAccred3;
        vm.setShowPanelAccred4 = setShowPanelAccred4;

        //Pannelli dei dati (viewAdes)
        vm.showPanelAdes1 = true;
        vm.showPanelAdes2 = true;
        vm.showPanelAdes3 = true;
        vm.showPanelAdes4 = true;
        vm.setShowPanelAdes1 = setShowPanelAdes1;
        vm.setShowPanelAdes2 = setShowPanelAdes2;
        vm.setShowPanelAdes3 = setShowPanelAdes3;
        vm.setShowPanelAdes4 = setShowPanelAdes4;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;

        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.saving = false;


        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fTMisuraCode = '';
        vm.fProgettoId = 0;
        vm.fTSourceCode = '';
        vm.fSourceId = 0;
        vm.fIFinestra = 0;
        vm.fISentConv = 0;
        vm.fIStato = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.tMisuraCode = vm.fTMisuraCode;
        vm.filter.progettoId = vm.fProgettoId;
        vm.filter.tSourceCode = vm.fTSourceCode;
        vm.filter.sourceId = vm.fSourceId;
        vm.filter.iFinestra = vm.fIFinestra;
        vm.filter.iSentConv = vm.fISentConv;
        vm.filter.iStato = vm.fIStato;

        vm.cndProgetto = {};
        vm.adesione = {};
        vm.urlRoot = datacontext.convenzione_getURL();

        vm.addOrUpdate = addOrUpdateItem;

        vm.testing = true;
        vm.validDateStart = true;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Ragione Sociale', 'Codice Fiscale', 'Cod Ateco', 'Forma Giuridica'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.attach = [];

        vm.list.b_attach = false;

        vm.list.pSedi = [];

        //Attach 2
        vm.tAttach_Needed = [];
        vm.tAttach_CONV = [];
        vm.list.attach_conv = [];


        vm.addAttach = addAttach;
        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.deleteAttach = deleteAttach;

        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        vm.populateAttach = populateAttach;
        vm.setAnnulled = setAnnulled;
        vm.modalAnnulled = modalAnnulled;

        vm.sendConv = sendConv;
        vm.sendConvReOpen = sendConvReOpen;
        vm.sendConvEsito = sendConvEsito;


        //Conteggio Elenchi
        vm.countAttachProfilo = function () {
            var filter = {};
            return filterFilter(vm.list.attach, filter).length;
        };


        //Filtro
        vm.fAttach = {};
        vm.setfAttach = setfAttach;

        //Elenchi per filtri e finestra modale di Create
        vm.cmblist = {};
        vm.cmblist.tMisure = [];
        vm.cmblist.tIndirizzi = [];
        vm.cmblist.sedeOp_comuni = [];
        vm.cmblist.sedeOp_province = [];
        vm.cmblist.sedeOp_tIndirizzi = [];

        vm.cmblist.sedeLeg_comuni = [];
        vm.cmblist.sedeLeg_province = [];
        vm.cmblist.sedeLeg_tIndirizzi = [];


        vm.cmblist.province = [];
        vm.cmblist.comuni = [];

        vm.resetComuni = resetComuni;

        vm.resetComuni_SedeOp = resetComuni_SedeOp;
        vm.resetComuni_SedeLeg = resetComuni_SedeLeg;
        vm.reset_SedeOperativa = reset_SedeOperativa;

        vm.reset_Trc1Avviato = reset_Trc1Avviato;
        vm.reset_Trc2Avviato = reset_Trc2Avviato;



        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;


        vm.setCompleted = setCompleted;
        vm.setSent = setSent;
        vm.unlock = unlockItem;
        vm.setAttachChecked = setAttachChecked;

        //vm.get = getRecord;
        //vm.update = saveOrUpdateItem;

        vm.saveConv = saveOrUpdateConv;
        vm.delete = deleteItem;
        vm.download = downloadItem;

        vm.deleteDtl = deleteDtlItem;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;


        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;


        vm.printAll = printAll;
        vm.setStep = setStep;

        //Tirocinio
        vm.getNrMesiTrc = getNrMesiTrc;
        vm.validDate = true;
        vm.getValidDate = getValidDate;

        vm.change_misura = change_misura;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            vm.opened4 = false;
            vm.opened5 = false;
            vm.opened6 = false;
            vm.opened7 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
            else if (iOpened == 3) vm.opened3 = true;
            else if (iOpened == 4) vm.opened4 = true;
            else if (iOpened == 5) vm.opened5 = true;
            else if (iOpened == 6) vm.opened6 = true;
            else if (iOpened == 7) vm.opened7 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.DDG_Dt = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.M_DtAgg = '';
                vm.changed = true;
            }
            else if (iOpened == 3) {
                vm.record.M_DtPubbl = '';
                vm.changed = true;
            }
            else if (iOpened == 4) {
                vm.record.M_DtAccred = '';
                vm.changed = true;
            }/*
            else if (iOpened == 5) {
                vm.record.Tir1_DtEnd = '';
                vm.changed = true;
                vm.nrMesiTrc = 0;
                vm.validDate = true;
            }
            else if (iOpened == 6) {
                vm.record.Tir2_DtStart = '';
                vm.changed = true;
                vm.nrMesiTrc = 0;
                vm.validDate = true;
            }
            else if (iOpened == 7) {
                vm.record.Tir2_DtEnd = '';
                vm.changed = true;
                vm.nrMesiTrc = 0;
                vm.validDate = true;
            }
            */
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';


        // ---- ACTIVATE -------
        loadStepParams();
        activate();


        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.convenzioneUID != null) {
                        return getRecordByUID($routeParams.convenzioneUID).then(function () {
                            if (!vm.record.Completed) {
                                var promises = [getAuthorization(), getTSourceCONV(), getTAttach(vm.tSourceCode_CONV), getTAttachNeededCONV(), getProvince(), getTIndirizzi(), getProvince_SedeReg(), getTIndirizzi_SedeReg(), getProvince_SedeLeg(), getTIndirizzi_SedeLeg() /*, getTAttachNeededAdes(), getTSourceADES(), getTitoliStudio(), getPaesi_Nasc(), getProvince_Nasc(), getPaesi_NascTir(), getProvince_NascTir(), getProvince_TrcObbl(), getProvince(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom(), getPaesi_ResTir(), getProvince_ResTir(), getPaesi_DomTir(), getProvince_DomTir(), getProvince_SedeTir(), getCittadinanze()*/];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.AttachChecked) {
                                var promises2 = [getAuthorization(), getTSourceCONV(), getTAttach(vm.tSourceCode_CONV), getTAttachNeededCONV() /*, getTAttachNeededAdes() , getTSourceADES()*/];
                                return common.activateController(promises2, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        var promises = [getAuthorization(), getTSourceCONV(), getTAttach(vm.tSourceCode_CONV), getTAttachNeededCONV(), getProvince(), getTIndirizzi(), getProvince_SedeReg(), getTIndirizzi_SedeReg(), getProvince_SedeLeg(), getTIndirizzi_SedeLeg() /*, getTAttachNeededAdes(), getTSourceADES(), getTitoliStudio(), getPaesi_Nasc(), getProvince_Nasc(), getPaesi_NascTir(), getProvince_NascTir(), getProvince_TrcObbl(), getProvince(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom(), getPaesi_ResTir(), getProvince_ResTir(), getPaesi_DomTir(), getProvince_DomTir(), getProvince_SedeTir(), getCittadinanze()*/];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }
                });
            }
            else {
                var promises = [getAuthorization(), getTMisure(), getProvince_SedeOp(), getProvince(), getTIndirizzi(), getTIndirizzi_SedeOp(), getProvince_SedeLeg(), getTIndirizzi_SedeLeg() /*, getTAttachNeededAdes(), getTSourceADES(), getTitoliStudio(), getPaesi_Nasc(), getProvince_Nasc(), getPaesi_NascTir(), getProvince_NascTir(), getProvince_TrcObbl(), getProvince(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom(), getPaesi_ResTir(), getProvince_ResTir(), getPaesi_DomTir(), getProvince_DomTir(), getProvince_SedeTir(), getCittadinanze()*/];
                return common.activateController(promises, controllerId)
                    .then(function () {



                        if ($routeParams.TRuoloCode != null) {
                            vm.fTRuoloCode = $routeParams.TRuoloCode;
                            vm.TRuoloCode_def = $routeParams.TRuoloCode;
                            switch (vm.fTRuoloCode) {
                                case 'AZD_PROM-LAV1':
                                    vm.title += ' Avviso 1/2022';
                                    vm.fTMisuraCode = 'LAV1';
                                    vm.fTSourceCode = 'PART';
                                    vm.tSourceCode_CONV = 'CONV_LAV1';
                                    break;
                                case 'AZD_PROM-FAM1':
                                    vm.title += ' Avviso 2/2022';
                                    vm.fTMisuraCode = 'FAM1';
                                    vm.fTSourceCode = 'PART';
                                    vm.tSourceCode_CONV = 'CONV_FAM1';
                                    break;
                                case 'AZD_FORM-LAV1':
                                    vm.title += ' Avviso 5/2024';
                                    vm.fTMisuraCode = 'FORM_LAV1';
                                    vm.fTSourceCode = 'PART';
                                    vm.tSourceCode_CONV = 'CONV_FORM_LAV1';
                                    break;
                                case 'AZD_FORM-FAM1':
                                    vm.title += ' Avviso 4/2024';
                                    vm.fTMisuraCode = 'FORM_FAM1';
                                    vm.fTSourceCode = 'PART';
                                    vm.tSourceCode_CONV = 'CONV_FORM_FAM1';
                                    break;
                                default:
                                    vm.tSourceCode_CONV = 'CONV';
                                    break;
                            }
                            vm.sectionMenu = sectionMenu.setSection(vm.title);

                            change_misura();
                        }


                        getTSourceCONV();
                        getTAttach(vm.tSourceCode_CONV);
                        getTAttachNeededCONV();

                        if ($routeParams.ifinestra != null) {
                            vm.fIFinestra = parseInt($routeParams.ifinestra);
                        }

                        return cerca();
                    });
            }
        }

        //****************************************************
        // METODI GESTIONE AUTORIZZAZIONI
        //****************************************************
        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function () {
                vm.addDisabled = true;
                //Auth. specifica
                vm.isSpecial = (vm.isSUPER || vm.isIstruttore || vm.isFAM || vm.isUMC || vm.isCPI || vm.isCIAPI);
                if (vm.isUMC || vm.isIstruttore || vm.isFAM) {
                    //Di Default "Con ricevuta"
                    vm.fIStato = 4;
                }
            });
        }


        //****************************************************
        // METODI GESTIONE VIEW
        //****************************************************
        function setView(view) {
            console.info('setView', view);
            return vm.view = view;
        }

        //****************************************************
        // METODI GESTIONE ELENCO
        //****************************************************


        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.activated = true;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.tMisuraCode = vm.fTMisuraCode == null ? '' : vm.fTMisuraCode;
            vm.filter.progettoId = vm.fProgettoId == null ? 0 : vm.fProgettoId;
            vm.filter.tSourceCode = vm.fTSourceCode == null ? 0 : vm.fTSourceCode;
            vm.filter.sourceId = vm.fSourceId == null ? 0 : vm.fSourceId;
            vm.filter.iFinestra = vm.fIFinestra == null ? 0 : vm.fIFinestra;
            vm.filter.iSentConv = vm.fISentConv == null || vm.fISentConv == '' ? 0 : vm.fISentConv;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;
            vm.filter.uid = '';

            vm.loading = false;

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.cndConvenzione_countAll(vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.progettoId, vm.filter.tSourceCode, vm.filter.sourceId, vm.filter.iFinestra, vm.filter.iSentConv, vm.filter.iStato, vm.filter.uid)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;

            return datacontext.cndConvenzione_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.progettoId, vm.filter.tSourceCode, vm.filter.sourceId, vm.filter.iFinestra, vm.filter.iSentConv, vm.filter.iStato, vm.filter.uid, vm.ordine)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            var subject = 'Link%20di%20accesso%20alla%20convenzione';
                            var url = datacontext.convenzione_getURL();
                            var body = 'Salve,%0Dil%20link%20per%20accedere%20alla%20sua%20convenzione%20e\'%20il%20seguente:%0D%0D' + url + item.ProgettoUID + '/' + item.UID + '%0D%0DCordiali%20saluti.';
                            item.MailTo1 = 'mailto:' + item.SedeLeg_Email + '?subject=' + subject + '&body=' + body;
                            //console.info('vm.rec', item);
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function nextStep() {
            if (vm.record.Sent) {
                setStep(vm.actualStep + 1);
            }
            else {
                bDialog.confirmationDialog('FASE SUCCESSIVA', 'Si ricorda di verificare di aver compilato correttamente la sezione 3. Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                    function () { //YES
                        if (!vm.record.Dlgs196) return bDialog.errorDialog('Attenzione, autorizzazione al trattamento dei dati personali ai sensi del Decreto Legislativo 30 giugno 2003, n. 196 e s.m.i. mancante. ');
                        setStep(vm.actualStep + 1);
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Schema di Convenzione";
            vm.descriptionsStep[0] = "&Egrave; richiesto l'inserimento dei dati necessari alla compilazione dello 'Schema di Convenzione'.<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Upload Documentale";
            vm.descriptionsStep[1] = "Occore scaricare la convenzione, generata dal portale. Il documento deve essere firmato digitalmente e ricaricato unitamente all'eventuale altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Riepilogo";
            vm.descriptionsStep[2] = "&Egrave; possibile visualizzare l'esito della compilazione dello 'Schema di convenzione'. Inoltre, &egrave possibile stampare la 'Ricevuta di trasmissione della Convenzione'. ";
        }

        function setStepDefault() {
            if (vm.record.AttachChecked) {
                setStep(2);
            } else if (vm.record.Completed) {
                setStep(1);
            } else if (vm.record != undefined) {
                setStep(0);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            vm.subStep = "";
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    vm.actualAdesione = 0;
                    break;
                case 1:
                    vm.actualAdesione = 0;
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 2:

                    setView('viewRiep');
                    break;
                /*case 3:
                    vm.actualAdesione = 0;                                  
                    setView('viewRiep');
                    
                    break;*/
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = vm.record != undefined && vm.record.Completed;
            //vm.stepCompleted[1] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[1] = vm.record != undefined && vm.record.AttachChecked;
            vm.stepCompleted[2] = vm.record != undefined && vm.record.Sent;

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                /*case 'viewAdes':
                    if (vm.record.Id > 0)
                        able = true;
                    break;*/
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < vm.maxStep - 1 && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid || vm.saving;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.record.Completed || !vm.validDateStart;
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }



        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }



        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }
        function setShowPanelAccred3() {
            return vm.showPanelAccred3 = !vm.showPanelAccred3;
        }
        function setShowPanelAccred4() {
            return vm.showPanelAccred4 = !vm.showPanelAccred4;
        }

        //Gestione per viewAdes
        function setShowPanelAdes1() {
            return vm.showPanelAdes1 = !vm.showPanelAdes1;
        }
        function setShowPanelAdes2() {
            return vm.showPanelAdes2 = !vm.showPanelAdes2;
        }
        function setShowPanelAdes3() {
            return vm.showPanelAdes3 = !vm.showPanelAdes3;
        }
        function setShowPanelAdes4() {
            return vm.showPanelAdes4 = !vm.showPanelAdes4;
        }

        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }

        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }



        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('callExpired');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        //console.info('getCNDProgetto', data);
                        var dt = new Date(vm.cndProgetto.DttmServer);
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                        vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                        vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                        vm.isClickDay = vm.cndProgetto.IsClickDay;

                        vm.endTime = vm.dtStartClickDay;
                        vm.countdown = (vm.dtStartClickDay - dt) / 1000;

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }


                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUID(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('callExpired');
                    }
                );
        }

        $scope.$on('timer-tick', function (event, args) {
            if (args.millis == 0) {
                //console.info('timer-tick', args.millis);
                //vm.isClickDay = true;
            }
        });

        vm.goStepB = function () {
            if (vm.isSUPER) {
                nextStep();
            }
            else {
                setCompleted()
            }
        };

        function setCompleted() {
            if (!vm.record.Completed) {
                bDialog.confirmationDialog('Attenzione', 'Questa operazione comporta la convalida delle informazioni inserite nella "Fase A", pertanto non sar\xE0 possibile apportare modifiche successivamente. Vuoi proseguire?', 'Convalida e procedi').then(
                    function () { //YES
                        if (vm.record.AG_Enabled && vm.record.AG_MinUtenti == 0 || vm.record.CL_Enabled && vm.record.CL_MinUtenti == 0 || vm.record.CT_Enabled && vm.record.CT_MinUtenti == 0
                            || vm.record.EN_Enabled && vm.record.EN_MinUtenti == 0 || vm.record.ME_Enabled && vm.record.ME_MinUtenti == 0 || vm.record.PA_Enabled && vm.record.PA_MinUtenti == 0
                            || vm.record.SR_Enabled && vm.record.SR_MinUtenti == 0 || vm.record.RG_Enabled && vm.record.RG_MinUtenti == 0 || vm.record.TP_Enabled && vm.record.TP_MinUtenti == 0
                        ) return bDialog.errorDialog('Attenzione: non sono stati compilati i campi relativi al "Numero minimo di utenti per provincia" (Step n. 3)');

                        vm.record.Completed = true;
                        vm.PdfReady = false;
                        vm.loading = true;
                        return saveOrUpdateConv().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            setClassSeqWiz();
                            setStep(1);
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(0);
                    }
                );
            }
            else {
                nextStep();
            }
        }

        function setSent() {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti.', 'Procedi').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return saveOrUpdateConv().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                                return true;
                            }
                            setClassSeqWiz();
                            printRicevuta();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                printRicevuta();
            }
        }

        function setAttachChecked() {
            if (!vm.record.AttachChecked) {
                bDialog.confirmationDialog('Attenzione', 'Si sta proseguendo alla "Fase C", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ', 'Procedi').then(
                    function () { //YES
                        vm.record.AttachChecked = true;
                        vm.loading = true;
                        return saveOrUpdateConv().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.AttachChecked = false;
                                setStep(1);
                                return false;
                            }
                            setClassSeqWiz();
                            setStep(2);
                            //setView('viewRiep');
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(1);
                        return true;
                    }
                );
            }
            else {
                setClassSeqWiz();
                setStep(2);
            }
        }

        function unlockItem(index) {
            if (!index) return;

            var item = vm.record;
            var msg = 'Sei sicuro di voler sbloccare la domanda: ' + item.UID + ' ? ';
            switch (index) {
                case 1:
                    vm.record.Completed = false;
                    msg = msg + ' Attenzione, proseguendo verranno eliminati gli allegati A e B associati. ';
                    break;
                case 2:
                    vm.record.AttachChecked = false;
                    break;
                case 3:
                    vm.record.Sent = false;
                    break;
                case 31:
                    vm.record.Sent = false;
                    vm.record.DeepRicevuta = true;
                    break;
                case 4:
                    vm.record.bConvalida = false;
                    break;
                case 5:
                    vm.record.SentPEC = false;
                    break;
            }

            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.cndConvenzione_unlock(item).then(function (data) {
                        if (data == "404") return logError('Errore: operazione non consentita');
                        setRecord(data);
                        vm.records[vm.index] = vm.record;
                        switch (index) {
                            case 1:
                                setStep(1);
                                break;
                            case 2:
                                setStep(2);
                                break;
                        }

                    });
                },
                function () { //NO
                    switch (index) {
                        case 1:
                            vm.record.Completed = true;
                            break;
                        case 2:
                            vm.record.AttachChecked = true;
                            break;
                        case 3:
                        case 31:
                            vm.record.Sent = true;
                            vm.record.DeepRicevuta = false;
                            break;
                        case 4:
                            vm.record.bConvalida = true;
                            break;
                        case 5:
                            vm.record.SentPEC = true;
                            break;
                    }
                }
            );
        }

        //*******************************
        // Print PDF CONVENZIONE

        function printAll(code) {
            vm.loading = true;

            $('#loadingModal').modal('show');
            return datacontext.pdf_printConvenzione(vm.record.ProgettoUID, vm.record.UID, vm.record.TMisuraCode)
                .then(function (response) {
                    $('#loadingModal').modal('hide');
                    vm.loading = false;
                    var status = response.status;
                    var data = response.data;

                    if (response == null || $.isNumeric(status)) {
                        if (status == 417) {
                            return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                        }
                        return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                    }
                    else if (response && response.url) {

                        var url = response.url;
                        var name = 'Convenzione_' + vm.record.TMisuraCode + '_' + vm.record.Id + '.pdf';

                        window.open(url, name);

                        //recupero allegato appena creato
                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //document.body.appendChild(a);

                        //a.href = response.url;
                        //if ($rootScope.detectIE()) {
                        //    a.target = 'hiddenIframe';
                        //}
                        //else
                        //    a.download = 'Allegato_' + vm.record.TMisuraCode + '_' + vm.record.Id + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);

                        return vm.linkPDFAllD = response.url;
                    } else
                        return true;
                });
        }

        function printRicevuta() {
            if (vm.record.Sent) {
                vm.loading = true;
                $('#loadingModal').modal('show');
                return datacontext.pdf_printConvenzioneRicevuta(vm.record.ProgettoUID, vm.record.UID, vm.record.TMisuraCode)
                    .then(function (response) {
                        $('#loadingModal').modal('hide');
                        vm.loading = false;
                        var status = response.status;
                        var data = response.data;

                        if (response == null || $.isNumeric(status)) {
                            if (status == 417) {
                                return bDialog.errorDialog('Attenzione si \xE8 verificato il seguente problema: ' + data);
                            }
                            return bDialog.errorDialog('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                        }
                        else if (response && response.url) {

                            var url = response.url;
                            var name = 'Ricevuta_' + vm.record.UID + '.pdf';

                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //document.body.appendChild(a);

                            //a.href = response.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = 'Ricevuta_' + vm.record.UID + '.pdf';
                            //a.click();
                            //document.body.removeChild(a);

                            return response.url;
                        } else
                            return true;
                    });
            }
        }

        function setRecord(data) {
            vm.record = data;
            //console.info('vm.record', vm.record);

            //CountDown            
            if (vm.record.ShowCountdown) {
                vm.targetDate = new Date(vm.record.CountdownDtEnd);
                vm.targetDateString = vm.targetDate.toISOString();
                vm.textFinished = 'Termini scaduti';
                vm.textSuccess = 'Presentato nei termini';
            }

            vm.record.ATT_TSourceCode = vm.tSourceCode_CONV;

            if (vm.record.Deleted || vm.record.Annulled) {
                vm.errorAccess = 'callExpired';
                return;
            }
            if (vm.record.Completed)
                return;

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;
            vm.validPIVA = true;

            if (vm.record.DDG_Dt != null) vm.record.DDG_Dt = new Date(vm.record.DDG_Dt);
            if (vm.record.M_DtAgg != null) vm.record.M_DtAgg = new Date(vm.record.M_DtAgg);
            if (vm.record.M_DtPubbl != null) vm.record.M_DtPubbl = new Date(vm.record.M_DtPubbl);
            if (vm.record.M_DtAccred != null) vm.record.M_DtAccred = new Date(vm.record.M_DtAccred);

            //Aggiorno campi
            getComuni_SedeOp(vm.record.SedeOp_ProvinciaId);
            getComuni_SedeLeg(vm.record.SedeLeg_ProvinciaId);
            getComuni(vm.record.ProvinciaId);
            getCNDPartecipazioneSedi();

            vm.records[vm.index] = vm.record;
            setView('detail');
        }


        function getRecord(id, index) {
            console.log('getRecord');
            vm.index = index;
            return datacontext.cndConvenzione_get(id).then(function (data) {
                //console.info('getRecord', data);
                console.log(data);
                if (!vm.isSpecial && (data == null || $.isNumeric(data) || data.Id == 0 || !data.ProgettoCND_On)) {
                    return showAlertDivs('callExpired');
                }

                setRecord(data); //vm.record = data;
                setStepDefault();
            });
        }

        function showAlertDivs(errorAccess) {

            setView('detail');
            vm.errorAccess = errorAccess;

            return false;
        }

        function getRecordByUID(uid) {
            return datacontext.cndConvenzione_getByUID(uid, $routeParams.projectUID).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('callExpired');
                    return false;
                }

                //Parametro di appoggio per send_Email
                vm.record.ProgettoUId = $routeParams.projectUID;
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;


                setRecord(data); //vm.record = data;
                setStepDefault();
            });
        }

        function saveOrUpdateConv() {
            if (typeof vm.record.Id == 'undefined' || vm.record.Id == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta effettuando il primo salvataggio; la pratica sar\xE0 acquisita nel sistema informativo. Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        //vm.record.ProgettoUId = $routeParams.projectUID;
                        //vm.record.iFinestra = vm.iFinestra;
                        vm.loading = true;
                        return datacontext.cndConvenzione_add(vm.record).then(function (data) {
                            vm.loading = false;
                            if (data == "400") {
                                logError('Errore campi non validi. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "409") {
                                logError(msgExistConv); //Domanda esistente
                                return data;
                            }
                            if (data == "300") {
                                logError('Errore: partita IVA non valida. ');
                                return data;
                            }
                            if (data == "501") {
                                logError('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if (data == "203") {
                                logError('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;

                                //$routeParams.convenzioneUID = vm.record.UID;

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;
                                }
                                return logSuccess('Dati salvati. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            } else {
                vm.loading = true;
                return datacontext.cndConvenzione_merge(vm.record).then(function (data) {
                    vm.loading = false;
                    //console.info('cndConvenzione_merge', data);
                    if (data == "304") {
                        bDialog.errorDialog('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "300") {
                        bDialog.errorDialog('Errore: partita IVA non valida. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.record.AttachChecked = false;
                        bDialog.errorDialog("Attenzione mancano alcuni allegati necessari, inserirli prima di passare alla Fase successiva. ");
                        return data;
                    }
                    if (data == "409") {
                        bDialog.errorDialog(msgExistConv); //Domanda esistente
                        return data;
                    }
                    if (data == "501") {
                        bDialog.errorDialog('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "203") {
                        vm.saving = false;
                        bDialog.errorDialog('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "406") {
                        bDialog.errorDialog('Errore: allegato non disponibile ');
                        return data;
                    }
                    if (data == "502") {
                        bDialog.errorDialog('Funzionalit\xE0 non ancora disponibile, vedi Linee Guida Avviso');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        bDialog.errorDialog('Errore generico. Impossibile proseguire.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        setStepDefault();
                        //$routeParams.convenzioneUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }

        function deleteDtlItem(item, index) {
            var msg = ' la sede : ' + item.Sede;
            bDialog.deleteDialog(msg).then(function () {
                item.Deleted = 1;
                return saveOrUpdateConv().then(function (data) {
                    if ($.isNumeric(data)) {
                        return logError('Si \xE8 verificato un errore ');
                    }
                    //var index = vm.record.CNDConvenzioniDtl.indexOf(item);
                    vm.record.CNDConvenzioniDtl.splice(index, 1);
                    return logSuccess('Sede eliminata');
                });
            });
        }


        function deleteItem(item) {
            var msg = ' la azienda : ' + item.RagioneSociale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndConvenzione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        function downloadItem(item) {
            $('#loadingModal').modal('show');
            return datacontext.attach_download(item.Id, vm.tSourceCode_CONV, 0, 0).then(function (data) {
                $('#loadingModal').modal('hide');
                if (data == '') return logError('Documentazione non disponibile.');
                var url = data;
                window.open(url, 'Download');
            });
        }


        function setAnnulled(locked) { //Se locked==true => 'Annullo' l'istanza; altrimenti la 'Riabilito'
            if (vm.record != null && vm.record.Id > 0) {
                var msg = 'Stai per annullare l\'istanza di ' + vm.record.Accred_L_CodiceFiscale + '. Procedere?';
                if (!locked) msg = 'Stai per riabilitare l\'istanza di ' + vm.record.Accred_L_CodiceFiscale + '. Procedere?';
                bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                    function () { //YES
                        return datacontext.cndConvenzione_setAnnulled(vm.record.Id, locked).then(function (data) {
                            if (data == "304") {
                                return logError('Errore sul "setAnnulled". ');
                            }
                            else {
                                vm.record.Annulled = locked;
                                vm.records[vm.index].Annulled = locked;

                                return logSuccess('Record modificato. ');
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        function modalAnnulled() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CND_Convenzione/BO/modal/convAnnulled.html?version=127',
                controller: 'convAnnulled',
                resolve: {
                    convenzione: function () {
                        return vm.record;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '-3') return logError('Errore: operazione non consentita');
                else if (returnItem == '-2') return logError('Errore: convenzione gi\xE0 trasmessa al dipartimento');
                else if (returnItem == '-1') return logError('Errore: inserisci una motivazione');
                else if (returnItem > 0) {
                    vm.record.Annulled = true;
                    vm.records[vm.index] = vm.record;
                }
            }, function () {
                vm.record.Annulled = false;
            });
        }

        vm.convDtlEdit = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CND_Convenzione/BO/modal/convDtlEdit.html?version=127',
                controller: 'convDtlEdit',
                backdrop: 'static',
                resolve: {
                    dtlId: function () {
                        return item.Id;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    provinciaId: function () {
                        return null;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                console.info('vm.convDtlEdit', returnItem);
                if (!returnItem) return logError('Errore');

                getRecord(vm.record.Id, vm.idex);
                logSuccess('record aggiornato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        function getCNDPartecipazioneSedi() {
            vm.list.pSedi = [];
            return datacontext.pSede_getAllList('', vm.record.CNDPartecipazioneId, 0, 0, 'AZD_PROM-LAV1', 0, -1, 0, 0, 0, 2).then(function (data) {
                //console.info('getCNDPartecipazioneSedi', data);
                return vm.list.pSedi = data;
            });
        }


        // ****************************************
        // INVIO CONVENZIONI

        function sendConv(progettoId, iFinestra) {
            var msg = 'Si sta per effettuarte l\'invio delle PEC ai soggetti ospitanti. Procedere? ';
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    //var progettoId = 10;
                    //var iFinestra = 1;
                    var iStato = 7;
                    return datacontext.cndConvenzione_sendConvenzione(progettoId, iFinestra, iStato).then(function (data) {
                        if (data == "406") return logError('Errore: parametri non validi');
                        if (data == "404") return logError('Errore: invio non completato');
                        if ($.isNumeric(data)) return logError('Errore generico');

                        return logSuccess('Invio completato con successo');
                    });
                },
                function () { //NO
                    //
                }
            );
        }

        function sendConvReOpen(progettoId, iFinestra) {
            var msg = 'Si sta per effettuarte l\'invio delle PEC ai soggetti ospitanti. Procedere? ';
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    //var progettoId = 10;
                    //var iFinestra = 1;
                    var iStato = 10;
                    return datacontext.cndConvenzione_sendConvenzioneReOpen(progettoId, iFinestra, iStato).then(function (data) {
                        if (data == "406") return logError('Errore: parametri non validi');
                        if (data == "404") return logError('Errore: invio non completato');
                        if ($.isNumeric(data)) return logError('Errore generico');

                        return logSuccess('Invio completato con successo');
                    });
                },
                function () { //NO
                    //
                }
            );
        }

        function sendConvEsito(progettoId, iFinestra, iStato, esito) {
            var msg = 'Si sta per effettuarte l\'invio delle PEC ai soggetti ospitanti con esito ' + esito + '. Procedere? ';
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.cndConvenzione_sendConvEsito(progettoId, iFinestra, iStato, esito).then(function (data) {
                        if (data == "406") return logError('Errore: parametri non validi');
                        if (data == "404") return logError('Errore: invio non completato');
                        if ($.isNumeric(data)) return logError('Errore generico');

                        return logSuccess('Invio completato con successo');
                    });
                },
                function () { //NO
                    //
                }
            );
        }

        // ****************************************
        //Function List

        function change_misura() {
            getProgetti(vm.fTRuoloCode);
        }

        function getTMisure() {
            if (vm.cmblist.tMisure.length > 0) return;

            return datacontext.tMisura_getAll().then(function (data) {
                return vm.cmblist.tMisure = data;
            });
        }

        function getProgetti(tRuoloCode) {
            //console.info('getProgetti', tRuoloCode);
            return datacontext.cndProgetto_getAll(0, 0, '', '', '', tRuoloCode, '', 3, '', '').then(function (data) {
                if (data.constructor == Array) {
                    var dt = new Date();
                    data.forEach(function (prog) {
                        var dtStart = new Date(prog.DtStart);
                        var dtEnd = new Date(prog.DtEnd);
                        if (dt >= dtStart && dt <= dtEnd) {
                            //vm.fIFinestra = prog.iFinestra;
                            vm.fProgettoId = prog.Id;
                        }
                    });
                }
                //console.info('progetti', data);
                return vm.cmblist.progetti = data;
            });
        }


        // ****************************************

        //Sede Legale
        function getProvince() {
            if (vm.cmblist.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = data;
            });
        }

        function resetComuni(idprov) {
            vm.record.ComuneId = 0;
            getComuni(idprov);
        }
        function getComuni(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.comuni = [];
            }

            if (vm.record.ProvinciaId != idprov)
                vm.cmblist.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni = data;
            });
        }

        function getTIndirizzi() {
            if (vm.cmblist.tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.tIndirizzi = data;
            });
        }

        //Sede Operativa
        function getProvince_SedeOp() {
            if (vm.cmblist.sedeOp_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeOp_province = data;
            });
        }

        function resetComuni_SedeOp(idprov) {
            vm.record.SedeOp_ComuneId = 0;
            getComuni_SedeOp(idprov);
        }
        function getComuni_SedeOp(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeOp_comuni = [];
            }

            if (vm.record.SedeOp_ProvinciaId != idprov)
                vm.cmblist.sedeOp_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeOp_comuni = data;
            });
        }

        function getTIndirizzi_SedeOp() {
            if (vm.cmblist.sedeOp_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.sedeOp_tIndirizzi = data;
            });
        }

        //Sede Legale
        function getProvince_SedeLeg() {
            if (vm.cmblist.sedeLeg_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeLeg_province = data;
            });
        }

        function resetComuni_SedeLeg(idprov) {
            vm.record.SedeLeg_ComuneId = 0;
            getComuni_SedeLeg(idprov);
        }
        function getComuni_SedeLeg(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeLeg_comuni = [];
            }

            if (vm.record.SedeLeg_ProvinciaId != idprov)
                vm.cmblist.sedeLeg_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeLeg_comuni = data;
            });
        }

        function getTIndirizzi_SedeLeg() {
            if (vm.cmblist.sedeLeg_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.sedeLeg_tIndirizzi = data;
            });
        }

        //Reset
        function reset_SedeOperativa() {
            if (vm.record.bSedeOperativa == undefined || vm.record.bSedeOperativa == false) {
                vm.record.SedeOp_TIndirizzoId = 0;
                vm.record.SedeOp_Indirizzo = '';
                vm.record.SedeOp_Civico = '';
                vm.record.SedeOp_CAP = '';
                vm.record.SedeOp_ProvinciaId = 0;
                vm.record.SedeOp_ComuneId = 0;
            }
        }

        function reset_Trc1Avviato() {
            if (vm.record.Tir1_IsAvviato) {
                vm.record.Tir1_DtStartPresunta = '';
                vm.validDateStart = true;
            }
            else {
                vm.record.Tir1_NumMesiAmmiss = '';
            }
        }

        function reset_Trc2Avviato() {
            if (vm.record.Tir2_IsAvviato) {
                vm.record.Tir2_DtStartPresunta = '';
            }
            else {
                vm.record.Tir2_NumMesiAmmiss = '';
            }
        }

        function getNrMesiTrc() {
            vm.nrMesiTrc = 0;
            if (vm.record.Tir1_DtStart != null && vm.record.Tir1_DtEnd != null) {
                var dtStart = moment(vm.record.Tir1_DtStart);
                var dtEnd = moment(vm.record.Tir1_DtEnd);

                //Differenza in mesi
                var diffValue = dtEnd.diff(dtStart, 'months', true);
                if (isNaN(diffValue))
                    diffValue = 0;

                if (diffValue < 0 || diffValue > 23) {
                    //Arrotondo per eccesso in ogni caso
                    vm.nrMesiTrc = (diffValue % 1) == 0 ? parseFloat(diffValue.toFixed()) : parseInt(diffValue) + 1;
                }
            }
            else
                vm.nrMesiTrc = 0;

            //console.info('getNrMesiTrc', diffValue, vm.nrMesiTrc);
            return vm.nrMesiTrc;
        }

        function getValidDate() {
            vm.validDate = true;
            if (vm.record.Tir1_DtStart != null && vm.record.Tir1_DtEnd != null) {
                if (vm.record.Tir1_DtStart > vm.record.Tir1_DtEnd)
                    vm.validDate = false;
            }

            return vm.validDate;
        }

        function addOrUpdateItem(item) {
            var msg = 'Attenzione, stai per sincronizzare i campi della convenzione con i dati in rubrica dell\'azienda. Procedere? ';
            bDialog.confirmationDialog('SINCRONIZZA CON AZIENDA DA RUBRICA', msg).then(
                function () { //YES
                    return datacontext.cndConvenzione_addOrUpdate(item).then(function (data) {
                        if (data < 0) return bDialog.errorDialog('Attenzione errore');
                        getRecord(vm.record.Id, vm.idex);
                        return logSuccess('Successo');
                    });
                },
                function () { //NO
                }
            );

        }

        function showMessage(text) {
            return bDialog.informationDialog(text);
        }


        //**********************************************************************
        //GESTIONE ATTACH 2

        function resetListAttach() {
            vm.conv_ref = '';
            vm.list.attach_conv = [];
        }

        function populateAttach() {
            //console.log('populateAttach()');
            resetListAttach();

            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.conv_ref = vm.record.Accred_L_Cognome + ' ' + vm.record.Accred_L_Nome + ' (' + vm.record.Accred_L_CodiceFiscale + ')';
                return getListAttach(vm.record.UID, vm.record.Id, vm.tSourceCode_CONV).then(function () {
                    vm.list.attach_conv = vm.list_ATT.slice();
                    return true;
                });
            }
        }

        // ATTACH 2
        function getListAttach(sourceUID, sourceId, tSourceCode) {
            if (!sourceId) return;
            vm.list_ATT = [];
            return datacontext.attach_getAll(0, 0, sourceId, 0, tSourceCode, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list_ATT = data_ATT;

                return datacontext.tAttach_getAll(0, 0, tSourceCode, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        //console.info('tAttVis', data_TAV);
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;

                            if (typeof vm.list_ATT == 'undefined') vm.list_ATT = [];
                            var myrec = _.find(vm.list_ATT, { 'TAttachId': item_TA.Id });

                            var myTAV = {};
                            var roleId = vm.authorization.RoleId;
                            if (roleId > 0) {
                                tAttVis.forEach(function (tAV) {
                                    if (tAV.RoleId == roleId && tAV.TAttachId == item_TA.Id)
                                        myTAV = tAV;
                                });
                            }
                            else {
                                myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });
                            }

                            if (typeof myTAV == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            //console.info('myTAV', myTAV);

                            if (typeof myrec == 'undefined') {
                                if (att.bRead)
                                    vm.list_ATT.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list_ATT, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length)
                                        vm.list_ATT.push(att);
                                }
                            }

                            //console.info('myrec', myrec);
                        });
                        //console.info('vm.list_ATT', vm.list_ATT);
                        return vm.list_ATT;
                    });
                });


            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {

                return vm.tAttach_Needed = data;
            });
        }

        function getTSourceCONV() {
            return datacontext.tSource_getByCode(vm.tSourceCode_CONV).then(function (data) {
                return vm.tSource_CONV = data;
            });
        }


        function getTAttachNeededCONV() {
            if (vm.tAttach_CONV.length > 0) return;
            return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_CONV, 0, '', 0, '').then(function (data) {
                //console.info('getTAttachNeededCONV', data);
                return vm.tAttach_CONV = data;
            });
        }

        function deleteAttach(item, value) {
            if (item == undefined || value == undefined || value == 0) return;

            var listATT = [];
            var tSourceCode = '';
            switch (parseInt(value)) {
                case 1:
                    listATT = vm.list.attach_conv;
                    tSourceCode = vm.tSourceCode_CONV;
                    break;
            }

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    //Popolo l'oggetto att da cancellare
                    var index = listATT.indexOf(item);
                    var att = {};
                    att.TAttachId = listATT[index].TAttachId;
                    att.TAttach = listATT[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        vm.tAttach_Needed = [];
                        switch (tSourceCode) {
                            case 'CONV':
                                vm.tAttach_Needed = vm.tAttach_CONV;
                                break;
                        }

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(listATT, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            listATT[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            listATT.splice(index, 1);
                        }
                    });
                });
            });
        }



        // ADD ATTACH2
        function addAttach(tAttachId) {
            var recTSource = { Id: vm.tSource_CONV.Id, Name: vm.tSource_CONV.Name };
            var recSource = { Id: vm.record.Id, Name: vm.conv_ref };
            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd2.html?version=127',
                controller: 'attachAdd2',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource_CONV.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource_CONV.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return vm.tAttach_CONV;
                    },
                    tAttachId: function () {
                        return tAttachId;
                    },
                    tSourceRefId: function () {
                        return null;
                    },
                    sourceRefId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '406') return logError('Errore: tipologia di allegato non permessa! ');
                if (returnItem == '400') return logError('Errore registrazione dati');


                logSuccess('Dato salvato con successo! ');
                populateAttach();
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }


        //*****************************************************
        //Elenchi Parametri

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }


        //Metodi interfaccia Filtri
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }


        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.getValidPIVA = function (value) {
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri            
            vm.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri            
            vm.validCF = false;
            return datacontext.validazione_cf(value).then(function (data) {
                return vm.validCF = data;
            });
        };


        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN1 = true;
        vm.getValidIBAN1 = function (value) {
            if (value == undefined) return;
            if (value.length != 27) return; //numero minimo di caratteri            
            vm.validIBAN1 = false;
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN1 = data;
            });
        };

        vm.validIBAN2 = true;
        vm.getValidIBAN2 = function (value) {
            if (value == undefined) return;
            if (value.length != 27) return; //numero minimo di caratteri     
            vm.validIBAN2 = false;
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN2 = data;
            });
        };



    }
})();
